import { render, staticRenderFns } from "./HandleProductSpecSidebar.vue?vue&type=template&id=6a6468d7&scoped=true&"
import script from "./HandleProductSpecSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleProductSpecSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleProductSpecSidebar.vue?vue&type=style&index=0&id=6a6468d7&prod&lang=scss&"
import style1 from "./HandleProductSpecSidebar.vue?vue&type=style&index=1&id=6a6468d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6468d7",
  null
  
)

export default component.exports